import React, { useState, useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { gql, useQuery } from "@apollo/client"
import _ from "lodash"
import trcss from "../../../styles/Telerecovery.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import { LoaderMedium } from "../../../components/Loaders"
import { InputTextarea } from "primereact/inputtextarea"

import { trApiSendSMSToParticipant } from "../telerecoveryApi"

export default function ParticipantSMSNew({ onMessageSent, staffPhoneNumber }) {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [newSMSText, setNewSMSText] = useState("")
  const [dropdownLabel, setDropdownLabel] = useState("Loading participants...")

  let GET_PARTICIPANTS = gql`
    query ParticipantsSidebar(
      $staff_id: ID!
      $organization_id: ID!
      $search_type: String
    ) {
      participants: getAllActiveParticipants(
        staff_id: $staff_id
        organization_id: $organization_id
        search_type: $search_type
      ) {
        participant_id
        participant_alias
        participant_membership_status
        participant_name_first
        participant_name_last
        participant_phone_primary
      }
    }
  `
  const { loading } = useQuery(GET_PARTICIPANTS, {
    variables: {
      staff_id: user.staff_id,
      organization_id: user.organization_id,
      search_type: "my_participants",
    },
    context: {
      headers: {
        //userCtx: JSON.stringify(user),
      },
    },
    skip: !user,
    fetchPolicy: "network-only",
    onCompleted: ({ participants }) => {
      const newParticipantList = participants
        .filter((p) => p.participant_phone_primary)
        .map((participant) => {
          return {
            participant_id: participant.participant_id,
            participant_alias: participant.participant_alias,
            participant_phone_primary: participant.participant_phone_primary,
            name: `${_.unescape(participant.participant_name_first)} ${_.unescape(
              participant.participant_name_last,
            )}`,
          }
        })

      setDropdownLabel("Select a Participant")
      var auxList = []
      newParticipantList.forEach((p) => {
        var alreadyInStaffConvList = Array.from(
          userCtx.gmParticipantsConvList.filter(
            (s) => s.caseId === p.participant_id,
          ),
        )
        if (alreadyInStaffConvList.length === 0) {
          auxList.push(p)
        }
      })
      return setParticipantsList(auxList)
    },
  })

  const [participantsList, setParticipantsList] = useState(null)
  const [selectedParticipant, setSelectedParticipant] = useState(null)
  const [sendingMessage, setSendingMessage] = useState(false)

  const sendMessage = () => {
    if (newSMSText === "" || sendingMessage === true || !selectedParticipant) {
      return
    }
    setSendingMessage(true)

    let smsData = {
      from: staffPhoneNumber,
      to: selectedParticipant.participant_phone_primary,
      body: newSMSText,
      peerId: user.staff_id,
      caseId: selectedParticipant.participant_id,
      soarOrganizationId: user.organization_id,
    }

    trApiSendSMSToParticipant(
      userCtx.tokens.getTelerecoveryToken(),
      smsData,
    ).then(
      (response) => {
        setSendingMessage(false)
        onMessageSent(selectedParticipant.participant_id)
      },
      (err) => console.log(err),
    )
  }

  if (sendingMessage) {
    return <LoaderMedium />
  }

  return (
    <div className={trcss.chatWrapper}>
      <div className={gMessages.newChatForm}>
        <h2>New SMS to participant</h2>
        <hr />
        <div className={gMessages.content}>
          <div className={gMessages.field} style={{ width: "100%" }}>
            <label className={gMessages.label}>Select Participant</label>
            <Dropdown
              value={selectedParticipant}
              options={participantsList}
              onChange={(e) => setSelectedParticipant(e.value)}
              showClear
              optionLabel="name"
              filter
              filterBy="name"
              className={gMessages.selector}
              placeholder={dropdownLabel}
            />
          </div>
          <div className={trcss.chatWindowFooter}>
            <InputTextarea
              placeholder="Type your message"
              autoResize
              className={trcss.newMessageBox}
              value={newSMSText}
              onChange={(e) => setNewSMSText(e.target.value)}
              rows={1}
              disabled={!selectedParticipant || sendingMessage}
            />
            <div style={{ display: "flex", alignItems: "end" }}>
              <Button className={trcss.sendBtn} onClick={() => sendMessage()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
